import {useTranslation} from "react-i18next";
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {swallowException} from "../../utils/appUtils";
import {getResourceErrorMessage, isResourceFailed} from "../../utils/resourceUtils";
import {useOrderManagement} from "../../hooks/ordersHooks";
import {Order} from "../../types/domain/order";

export interface Props {
    companyId: string;
    order: Order;
    open: boolean;
    onClose: (isSuccessful: boolean) => void;
}

export const OrderRemoveDialog: React.FC<Props> = ({companyId, order, open, onClose}) => {
    const {t} = useTranslation();
    const orderManagement = useOrderManagement();

    const handleSubmit = () => {
        orderManagement.reset();

        orderManagement
            .delete(companyId, order.id)
            .then(() => {
                onClose(true);
            })
            .catch(swallowException);
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)}>
            <DialogTitle>{t("dialogs.order_remove.title")}</DialogTitle>
            <DialogContent dividers>
                {isResourceFailed(orderManagement.resource) && (
                    <Alert severity="error" sx={{marginBottom: "1rem"}}>
                        {getResourceErrorMessage(orderManagement.resource)}
                    </Alert>
                )}
                <DialogContentText>{t("dialogs.order_remove.content", {orderId: order.id})}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => onClose(false)}>
                    {t("dialogs.actions.cancel")}
                </Button>
                <Button onClick={handleSubmit}>{t("dialogs.actions.confirm")}</Button>
            </DialogActions>
        </Dialog>
    );
};
